// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__djaaP","title":"Header_title__2po1I","side":"Header_side__3OonP"};